{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPIGroup} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/disclosure';
import statelyDocs from 'docs:@react-stately/disclosure';
import Anatomy from '../DisclosureAnatomy.svg';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a disclosure component.';
export const isSubpage = true;

# useDisclosure

<PageDescription>{docs.exports.useDisclosure.description}</PageDescription>

```tsx render files={["starters/hooks/src/Disclosure.tsx", "starters/hooks/src/Disclosure.css", "starters/hooks/src/Content.css"]}
"use client";
import {Disclosure} from 'hooks-starter/Disclosure';

<Disclosure title="System Requirements">
  Details about system requirements here.
</Disclosure>
```

## API

<Anatomy />

```tsx
<Disclosure>
  <Heading>
    <Button slot="trigger" />
  </Heading>
  <DisclosurePanel />
</Disclosure>
```

<FunctionAPIGroup
  functions={[
    {function: statelyDocs.exports.useDisclosureState, links: statelyDocs.links},
    {function: statelyDocs.exports.useDisclosureGroupState, links: statelyDocs.links},
    {function: docs.exports.useDisclosure, links: docs.links},
  ]}
/>

### DisclosureState

<InterfaceType {...statelyDocs.exports.DisclosureState} links={statelyDocs.links} />

### AriaDisclosureProps

<InterfaceType {...docs.exports.AriaDisclosureProps} />

### DisclosureAria

<InterfaceType {...docs.exports.DisclosureAria} />
